(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["audio-comparison"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  function formatTime(seconds) {
    seconds = Math.floor(seconds || 0);
    const minutes = Math.floor(seconds / 60) || 0;
    const seconds_display = seconds % 60 || 0;
    return minutes + ':' + (seconds_display < 10 ? '0' : '') + seconds_display;
  }

  const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
  let currentlyPlaying = null;
  const players = document.querySelectorAll('.simple-player');

  players.forEach(function (player) {
    const audio = player.querySelector('.native-audio');
    const playButton = player.querySelector('.play-button');
    const progressBar = player.querySelector('.progress-bar');
    const progressFill = player.querySelector('.progress-fill');
    const timeDisplay = player.querySelector('.time-display');
    const volumeButton = player.querySelector('.volume-button');
    const volumeSlider = player.querySelector('.volume-slider');
    const volumeFill = player.querySelector('.volume-fill');
    const playerId = player.dataset.playerId;

    if (!audio || !playButton || !progressBar || !progressFill || !timeDisplay) {
      console.error('Missing elements for player:', playerId);
      return;
    }

    audio.setAttribute('playsinline', '');
    audio.setAttribute('webkit-playsinline', '');

    let iosVolume = 1; // Simulated volume for iOS

    if (!isIOS) {
      audio.volume = 0.7;
    } else {
      audio.muted = false;
      iosVolume = 1;
    }

    function updateVolumeDisplay() {
      const volumeLevel = isIOS ? (audio.muted ? 0 : iosVolume) : audio.volume;

      if (volumeFill) {
        volumeFill.style.height = (volumeLevel * 100) + '%';
      }

      if (volumeButton) {
        const svg = volumeButton.querySelector('svg');
        if (svg) {
          if (volumeLevel === 0) {
            svg.innerHTML = '<path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>';
          } else if (volumeLevel < 0.3) {
            svg.innerHTML = '<path d="M7 9v6h4l5 5V4l-5 5H7z"/>';
          } else {
            svg.innerHTML = '<path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>';
          }
        }
      }
    }

    audio.addEventListener('loadedmetadata', function () {
      timeDisplay.textContent = '0:00 / ' + formatTime(audio.duration);
      updateVolumeDisplay();
    });

    playButton.addEventListener('click', function () {
      const svg = playButton.querySelector('svg');
      if (audio.paused) {
        if (currentlyPlaying && currentlyPlaying !== audio) {
          currentlyPlaying.pause();
          players.forEach(function (otherPlayer) {
            if (otherPlayer !== player) {
              const otherSvg = otherPlayer.querySelector('.play-button svg');
              if (otherSvg) {
                otherSvg.innerHTML = '<path d="M8 5v14l11-7z"/>';
              }
            }
          });
        }

        const playPromise = audio.play();
        if (playPromise !== undefined) {
          playPromise.then(function () {
            svg.innerHTML = '<path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>';
            currentlyPlaying = audio;
          }).catch(function (error) {
            console.error('Playback failed:', error);
            if (isIOS) {
              alert('Tap OK to enable audio playback');
            }
          });
        }
      } else {
        audio.pause();
        svg.innerHTML = '<path d="M8 5v14l11-7z"/>';
        if (currentlyPlaying === audio) {
          currentlyPlaying = null;
        }
      }
    });

    audio.addEventListener('timeupdate', function () {
      const percent = (audio.currentTime / audio.duration) * 100 || 0;
      progressFill.style.width = percent + '%';
      timeDisplay.textContent = formatTime(audio.currentTime) + ' / ' + formatTime(audio.duration);
    });

    progressBar.addEventListener('click', function (e) {
      const rect = progressBar.getBoundingClientRect();
      const clickPosition = (e.clientX - rect.left) / rect.width;
      audio.currentTime = clickPosition * audio.duration;
    });

    if (volumeButton) {
      volumeButton.addEventListener('click', function (e) {
        e.stopPropagation();
        if (isIOS) {
          audio.muted = !audio.muted;
        } else {
          if (audio.volume > 0) {
            volumeButton.dataset.prevVolume = audio.volume;
            audio.volume = 0;
          } else {
            audio.volume = parseFloat(volumeButton.dataset.prevVolume) || 0.7;
          }
        }
        updateVolumeDisplay();
      });
    }

    if (volumeSlider) {
      const handleVolumeChange = function (position) {
        const volumeValue = Math.max(0, Math.min(1, position));
        if (isIOS) {
          iosVolume = volumeValue;
          audio.muted = iosVolume < 0.05;
        } else {
          audio.volume = volumeValue;
        }
        updateVolumeDisplay();
      };

      volumeSlider.addEventListener('click', function (e) {
        e.stopPropagation();
        const rect = volumeSlider.getBoundingClientRect();
        const clickPosition = 1 - ((e.clientY - rect.top) / rect.height);
        handleVolumeChange(clickPosition);
      });

      volumeSlider.addEventListener('mousedown', function (e) {
        e.stopPropagation();
        const drag = function (e) {
          const rect = volumeSlider.getBoundingClientRect();
          const dragPosition = 1 - ((e.clientY - rect.top) / rect.height);
          handleVolumeChange(dragPosition);
        };
        const stop = function () {
          document.removeEventListener('mousemove', drag);
          document.removeEventListener('mouseup', stop);
        };
        document.addEventListener('mousemove', drag);
        document.addEventListener('mouseup', stop);
        drag(e);
      });
    }

    audio.addEventListener('ended', function () {
      const svg = playButton.querySelector('svg');
      svg.innerHTML = '<path d="M8 5v14l11-7z"/>';
      progressFill.style.width = '0%';
      timeDisplay.textContent = '0:00 / ' + formatTime(audio.duration);
      if (currentlyPlaying === audio) {
        currentlyPlaying = null;
      }
    });

    audio.addEventListener('error', function (e) {
      console.error('Audio error:', e);
      player.innerHTML = '<div style="color: red; padding: 10px; text-align: center;">Error loading audio</div>';
    });
  });

  if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
    document.body.classList.add('ios-device');
    document.addEventListener('touchstart', function () {}, false);
  }
});



  } catch(e) { console.error(e); }
})();
})();
